function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "labelText", "labelTypography", "labelEmphasis", "iconSize", "isOverlappingRelativeContainer", "onClick", "zIndex", "hasHoverOnLabel", "iconTouchAreaSpace", "hasInheritedLabelTypography"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef, useState } from "react";
import { usePopper } from "react-popper";
import OnColorContext from "../../../contexts/OnColorContext";
import useDeviceDetect from "../../../hooks/useDeviceDetect";
import { KeyboardEventKeys } from "../../../typings/types";
import isNotEmpty from "../../../utils/isNotEmpty";
import PortalContainerOrg, { PortalType } from "../../organisms/PortalContainerOrg";
import { Button, Icon, IconLarge, IconSmall, Overlay, StyledSpan, StyledTextAtm, TooltipWrapper, Trigger } from "./TooltipMol.styled";
import TooltipMolContent from "./TooltipMolContent";
export var defaultProps = {
  labelTypography: "small2",
  labelEmphasis: "medium",
  iconSize: "default"
};
function TooltipMol(_ref) {
  var children = _ref.children,
    labelText = _ref.labelText,
    _ref$labelTypography = _ref.labelTypography,
    labelTypography = _ref$labelTypography === void 0 ? defaultProps.labelTypography : _ref$labelTypography,
    _ref$labelEmphasis = _ref.labelEmphasis,
    labelEmphasis = _ref$labelEmphasis === void 0 ? defaultProps.labelEmphasis : _ref$labelEmphasis,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? defaultProps.iconSize : _ref$iconSize,
    isOverlappingRelativeContainer = _ref.isOverlappingRelativeContainer,
    onClick = _ref.onClick,
    zIndex = _ref.zIndex,
    hasHoverOnLabel = _ref.hasHoverOnLabel,
    iconTouchAreaSpace = _ref.iconTouchAreaSpace,
    _ref$hasInheritedLabe = _ref.hasInheritedLabelTypography,
    hasInheritedLabelTypography = _ref$hasInheritedLabe === void 0 ? false : _ref$hasInheritedLabe,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var _useDeviceDetect = useDeviceDetect(),
    isDesktop = _useDeviceDetect.isDesktop,
    isMobile = _useDeviceDetect.isMobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var wrapperRef = useRef(null);
  var iconJsx = /*#__PURE__*/React.createElement(IconSmall, {
    $onColor: onColor
  });
  if (iconSize === "default") {
    iconJsx = /*#__PURE__*/React.createElement(Icon, {
      $onColor: onColor
    });
  }
  if (iconSize === "large") {
    iconJsx = /*#__PURE__*/React.createElement(IconLarge, {
      $onColor: onColor
    });
  }
  var handleWrapperOnClick = function handleWrapperOnClick(event) {
    event.stopPropagation();
    if (labelText && onClick) {
      setIsOpen(false);
      return;
    }
    if (isMobile) {
      setIsOpen(!isOpen);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      event.stopPropagation();
      setIsOpen(!isOpen);
    }
    if (event.key === KeyboardEventKeys.ESC && isOpen) {
      event.preventDefault();
      event.stopPropagation();
      setIsOpen(false);
    }
    if (event.key === KeyboardEventKeys.TAB && isOpen) {
      setIsOpen(false);
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (labelText && onClick) {
      setIsOpen(false);
      return;
    }
    if (isDesktop) {
      setIsOpen(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (isDesktop) {
      setIsOpen(false);
    }
  };
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    referenceElement = _useState4[0],
    setReferenceElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    popperElement = _useState6[0],
    setPopperElement = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    arrowElement = _useState8[0],
    setArrowElement = _useState8[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      modifiers: [{
        name: "arrow",
        options: {
          element: arrowElement
        }
      }, {
        name: "preventOverflow",
        options: {
          padding: 20
        }
      }, {
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }],
      strategy: "fixed"
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var placement = attributes.popper ? attributes.popper["data-popper-placement"] : "top";
  var triggerElement = /*#__PURE__*/React.createElement(Trigger, {
    ref: setReferenceElement,
    $hasHover: iconSize === "large",
    $isActive: isOpen,
    $onColor: onColor,
    $iconTouchAreaSpace: iconTouchAreaSpace
  }, iconJsx);
  var labelWithTriggerElement = hasInheritedLabelTypography ? /*#__PURE__*/React.createElement(StyledSpan, null, labelText, " ", triggerElement) : /*#__PURE__*/React.createElement(StyledTextAtm, {
    typography: labelTypography,
    emphasis: labelEmphasis
  }, labelText, " ", triggerElement);
  var tooltipJsx = /*#__PURE__*/React.createElement(TooltipWrapper, _extends({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleWrapperOnClick,
    onKeyDown: handleKeyDown,
    ref: wrapperRef,
    $zIndex: zIndex,
    $isOverlappingRelativeContainer: !!isOverlappingRelativeContainer,
    $isOpen: isOpen,
    tabIndex: 0
  }, restProps), isNotEmpty(labelText) && hasHoverOnLabel ? labelWithTriggerElement : triggerElement, isOpen ? /*#__PURE__*/React.createElement(PortalContainerOrg, {
    portalType: PortalType.TOOLTIP
  }, isMobile ? /*#__PURE__*/React.createElement(Overlay, null) : null, /*#__PURE__*/React.createElement(TooltipMolContent, _extends({
    boxProps: {
      ref: setPopperElement,
      style: _objectSpread(_objectSpread({}, styles.popper), {}, {
        overflow: "unset"
      })
    },
    arrowProps: {
      ref: setArrowElement,
      style: {
        left: styles.arrow.left,
        transform: placement === "top" ? "".concat(styles.arrow.transform, " rotate(180deg)") : styles.arrow.transform,
        overflow: "initial"
      }
    },
    placement: placement
  }, attributes.popper), children)) : null);
  if (labelText && !hasHoverOnLabel) {
    var labelJsx = hasInheritedLabelTypography ? /*#__PURE__*/React.createElement(StyledSpan, null, labelText, " ", tooltipJsx) : /*#__PURE__*/React.createElement(StyledTextAtm, {
      typography: labelTypography,
      emphasis: labelEmphasis
    }, labelText, " ", tooltipJsx);
    if (onClick) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: onClick,
        $onColor: onColor,
        $hasInheritedLabelTypography: hasInheritedLabelTypography
      }, labelJsx);
    }
    return labelJsx;
  }
  return tooltipJsx;
}
export default TooltipMol;